const PAYMENT_LOGIN_MONITOR_KEY = "payment.login.monitor.v1";
const PAYMENT_LOGIN_MONITOR_WINDOW_MS = 3 * 60 * 1000;

export interface PaymentLoginMonitorPayload {
  source: string;
  plan?: string;
  paymentProvider?: string;
  isInappWebview?: boolean;
  appVersion?: string;
  pathname?: string;
}

interface PaymentLoginMonitorRecord extends PaymentLoginMonitorPayload {
  clickedAt: number;
}

function readPaymentLoginMonitorRecord():
  | PaymentLoginMonitorRecord
  | undefined {
  try {
    const raw = sessionStorage.getItem(PAYMENT_LOGIN_MONITOR_KEY);
    if (!raw) return undefined;
    const parsed = JSON.parse(raw) as PaymentLoginMonitorRecord;
    if (!parsed || typeof parsed.clickedAt !== "number") {
      sessionStorage.removeItem(PAYMENT_LOGIN_MONITOR_KEY);
      return undefined;
    }
    return parsed;
  } catch {
    return undefined;
  }
}

export function markPaymentClickForLoginMonitor(
  payload: PaymentLoginMonitorPayload
) {
  try {
    const next: PaymentLoginMonitorRecord = {
      ...payload,
      pathname: payload.pathname ?? window.location.pathname,
      clickedAt: Date.now(),
    };
    sessionStorage.setItem(PAYMENT_LOGIN_MONITOR_KEY, JSON.stringify(next));
  } catch {}
}

export function getRecentPaymentClickForLoginMonitor(
  windowMs = PAYMENT_LOGIN_MONITOR_WINDOW_MS
): PaymentLoginMonitorRecord | undefined {
  const record = readPaymentLoginMonitorRecord();
  if (!record) return undefined;
  if (Date.now() - record.clickedAt > windowMs) {
    clearPaymentClickForLoginMonitor();
    return undefined;
  }
  return record;
}

export function clearPaymentClickForLoginMonitor() {
  try {
    sessionStorage.removeItem(PAYMENT_LOGIN_MONITOR_KEY);
  } catch {}
}
